<template lang="pug">
  v-row
    v-col(cols=12)
      h1 Настройка курса
    v-col(cols=12 md=7 lg=7 xl=6)
      course-form(
        v-if="course"
        :course="course"
        :availableTypes="availableTypes"
      )
    v-col(cols=12 md=5 lg=5 xl=4)(v-if="!$loader.isLoading")
      v-sheet(color="grey lighten-5").sdo-radius.pa-6
        h2.mb-3 Действия
        courator-assign(
          v-if="$user.data.role === $conf.ROLES.organization.value"
          :course-id="courseId"
        )
        telegram-storage.mt-5(
          :course="course"
        )
        .mt-5(v-if="course.type === this.$conf.COURSE_TYPES.general")
          h4.mb-1 Связать курс с ПФДО
          p.grey--text Скопируйте код ниже и следуйте инструкциям
          copy-clipboard-field(
            :value="course.token"
            label="Токен"
          )
        v-btn(
          color="error darken-1"
          depressed
          outlined
          text
          rounded
          @click="deleteCourse"
        ).mt-5 Удалить курс
</template>

<script>
import GptSettings from '@/components/GPTSettings/index.vue';
import TelegramStorage from '@/components/TelegramStorage.vue';
import CourseForm from '@/components/Forms/CourseForm.vue';
import CouratorAssign from '../components/CouratorAssign.vue';

export default {
  components: {
    GptSettings,
    CourseForm,
    CouratorAssign,
    TelegramStorage,
  },
  data: () => ({
    availableTypes: [],
    users: null,
    course: null,
  }),
  computed: {
    courseId() {
      return Number(this.$route.params.id);
    },

  },
  created() {
    this.fetchCourse();
    this.getAvailableTypes();
  },
  methods: {
    async getAvailableTypes() {
      this.loading = true;
      const { data } = await this.$api.courses.availableTypes();
      this.availableTypes = data.data;
      this.loading = false;
    },
    async fetchCourse() {
      this.$loader.start();
      const { item } = await this.$api.courses.show(
        this.courseId,
        { expand: 'telegram' },
      );
      this.course = item;
      await this.course.fetchToken();
      this.$loader.stop();
    },
    deleteCourse() {
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Вы действительно хотите удалить курс?',
        message: 'После удаления вы не сможете его восстановить',
        method: async () => {
          await this.$api.courses.delete(this.courseId);
          this.$router.replace({ name: 'MyCourseList' });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-input__append-outer {
    margin: auto 6px auto 6px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
</style>
